/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useServiceCatalogUrl } from 'domain/shared/serviceCatalog';

const ServiceCatalogBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = useServiceCatalogUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Service Catalog" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default ServiceCatalogBreadcrumbs;
